import { jsx as _jsx } from "react/jsx-runtime";
import { OpenBalanceProvider } from "../context/OpenBalanceContext";
import { OpenBalancePageContent } from "./OpenBalancePageContent";
export const OpenBalancePage = () => {
    return (_jsx(OpenBalanceProvider, { children: _jsx(OpenBalancePageContent, {}) }));
};
